import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=207ac3cc&scoped=true"
import script from "./shouye.vue?vue&type=script&lang=js"
export * from "./shouye.vue?vue&type=script&lang=js"
import style0 from "./shouye.vue?vue&type=style&index=0&id=207ac3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ac3cc",
  null
  
)

export default component.exports